import React, { Component } from "react";
import { connect } from "react-redux";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { formatMessageWithValues, historyPush, formatMessage, withTooltip } from "@openimis/fe-core";
import { fetchMyEntities } from "../actions";
import { bindActionCreators } from "redux";
import { injectIntl } from 'react-intl';
import { ProgressOrError, Table } from "@openimis/fe-core";
import {Button, Fab, Grid, Paper, Divider, Typography} from "@material-ui/core";
import { Add } from "@material-ui/icons";




// const styles = theme => ({ 
//     page: theme.page,
// });

const styles = theme => ({
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
        height: "100%"
    },
});

class Diafpage extends Component {
    

    state = {
        page: 0,
        pageSize: 10,
        afterCursor: null,
        beforeCursor: null,
    }

    constructor(props) {
        super(props);
        this.rowsPerPageOptions = props.modulesManager.getConf("fe-dia_form", "rowsPerPageOptions", [5, 10, 15, 50, 100]);
    }

    componentDidMount() {
        this.query();
    }

    query = () => {
        let prms = [];
        prms.push(`first: ${this.state.pageSize}`);
        if (!!this.state.afterCursor) {
            prms.push(`after: "${this.state.afterCursor}"`)
        }
        if (!!this.state.beforeCursor) {
            prms.push(`before: "${this.state.beforeCursor}"`)
        }
        prms.push(`orderBy: ["insuree"]`);
        this.props.fetchMyEntities(prms);
    }

    onChangeRowsPerPage = (cnt) => {
        this.setState(
            {
                pageSize: cnt,
                page: 0,
                afterCursor: null,
                beforeCursor: null,
            },
            e =>this.query()
        )
    }

    onChangePage = (page, nbr) => {
        if (nbr > this.state.page) {
            this.setState((state, props) => ({
                page: state.page + 1,
                beforeCursor: null,
                afterCursor: props.diafPageInfo.endCursor,
            }),
                e => this.query()
            )
        } else if (nbr < this.state.page) {
            this.setState((state, props) => ({
                page: state.page - 1,
                beforeCursor: props.diafPageInfo.startCursor,
                afterCursor: null,
            }),
                e => this.query()
            )
        }
    }

    onAdd = () => {
        historyPush(this.props.modulesManager, this.props.history, "Dia_Form.route.add_diaf");
    }

    render() {
        const { intl, classes, fetchingDiaForm, errorDiaForm, DiaForm, diafPageInfo } = this.props;

        let headers = [ 
            "Diaf.totalIncome",
            "Diaf.totalExpenditure",
            "Diaf.difference",
            "Diaf.shortfallDisposableIncome",        
        ]

        let itemFormatters = [
            e => e.totalIncome,
            e => e.totalExpenditure,
            e => e.difference,
            e => e.shortfallDisposableIncome
    ]

        return(
            <div className={classes.page}>
                <ProgressOrError progress={fetchingDiaForm} error={errorDiaForm} />
                    <Paper className={classes.paper}>      
                        <Table
                            module="DiaForm"
                            header={formatMessageWithValues(intl, "DiaForm", "DiaForm.Table", {count: diafPageInfo.totalCount})}
                            headers={headers}
                            itemFormatters={itemFormatters}
                            items={DiaForm}
                            withPagination={true}
                            page={this.state.page}
                            pageSize={this.state.pageSize}
                            count={diafPageInfo.totalCount}
                            onChangePage={this.onChangePage}
                            onChangeRowsPerPage={this.onChangeRowsPerPage}
                            rowsPerPageOptions={this.rowsPerPageOptions}
                        />
                       
                    </Paper> 
                    {withTooltip(
                            <div align="right" className={classes.fab}>
                                <Fab color="primary"
                                    onClick={this.onAdd}>
                                        <Add />
                                    </Fab>
                            </div>,
                            formatMessage(intl, "diaf", "addNewDiafTooltip")
                        )
                        }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    fetchingDiaForm: state.diaf.fetchingDiaForm,
    errorDiaForm: state.diaf.errorDiaForm,
    fetchedDiaForm: state.diaf.fetchedDiaForm,
    DiaForm: state.diaf.DiaForm,
    diafPageInfo: state.diaf.diafPageInfo,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ fetchMyEntities }, dispatch)
}
export default injectIntl(withTheme(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Diafpage))));